let dt_index = null;
let microsite_id = null;

export function index(params){

    dt_index = $('#microsite_tokens_table').DataTable({
        ajax: {
            url: $('#microsite_tokens_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: 'id', orderable: false, searchable: false, checkboxes: { selectRow: true } },
            { data: 'name', orderable: true, searchable: true },
            { width: '100', data: 'created_at', orderable: true, searchable: true, render: datatables.render_datetime_seconds },
        ],
        order: [[1, 'asc']],
    });

    dt_index.on('init', function(e, settings, json){
        $(settings.nTableWrapper).find('.table_batch_actions [action="delete_tokens"]').click(batch_delete_tokens);
    });

    microsite_id = params.microsite_id;

    $('#modal_new_token').on('hidden.bs.modal', function(){
        $('#modal_new_token input[name="token"]').val('');
    });
    
}

export function new_token_created(token){
    index_force_reload();
    $('#modal_add_token').modal('hide');
    $('#modal_new_token input[name="token"]').val(token.token);
    $('#modal_new_token').modal('show');
}

export function index_reload(){

    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}

function batch_delete_tokens(params){

    const table = $(this).closest('.dataTables_wrapper').find('.dataTable').DataTable();
    const rows_selected = table.column(0).checkboxes.selected();
    const route = window._routes['microsites.tokens.batch_delete'].replace('{microsite}', microsite_id);
    
    let tokens_id = [];
    $.each(rows_selected, function(index, rowId){
        tokens_id.push(rowId);
    });
    
    if(tokens_id.length == 0){

        window.messages.error(__('No has seleccionado ningún token'));

    } else {

        const title = __('Eliminar tokens');
        const text = 
            trans_choice('{1} Estás a punto de eliminar un token.|[2,*] Estás a punto de eliminar :count tokens.', tokens_id.length)
            + ' ' + __('Esta acción no se puede deshacer ¿quieres continuar?');
        
        window.messages
            .confirm(title, text)
            .then(
                _ => {

                    let formData = new FormData();
                    formData.append('microsite_id', microsite_id);
                    for(let token_id of tokens_id){
                        formData.append('tokens_id[]', token_id);
                    }

                    window.forms.post(route, formData);

                }, 
                _ => {}
            );

    }

}